export const venueIdGETPath = () => '/auth/venue';
